<script lang="ts">
    export let height = "h-4";
    export let width = "w-4";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-mdark";
    export let hover = "group-hover:stroke-mblue group-hover:fill-mblue";
    export let strokeWidth = "0.1";
    export let classList = "aspect-ratio transition-all";
</script>

<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
>
    <path d="M7.99992 9.44667C6.57992 9.44667 5.41992 8.29333 5.41992 6.86667C5.41992 5.44 6.57992 4.29333 7.99992 4.29333C9.41992 4.29333 10.5799 5.44667 10.5799 6.87334C10.5799 8.3 9.41992 9.44667 7.99992 9.44667ZM7.99992 5.29333C7.13326 5.29333 6.41992 6 6.41992 6.87334C6.41992 7.74667 7.12659 8.45333 7.99992 8.45333C8.87326 8.45333 9.57992 7.74667 9.57992 6.87334C9.57992 6 8.86659 5.29333 7.99992 5.29333Z"/>
    <path d="M8.00012 15.1734C7.01345 15.1734 6.02012 14.8 5.24678 14.06C3.28012 12.1667 1.10678 9.14671 1.92678 5.55337C2.66678 2.29337 5.51345 0.833374 8.00012 0.833374C8.00012 0.833374 8.00012 0.833374 8.00678 0.833374C10.4935 0.833374 13.3401 2.29337 14.0801 5.56004C14.8935 9.15337 12.7201 12.1667 10.7534 14.06C9.98012 14.8 8.98678 15.1734 8.00012 15.1734ZM8.00012 1.83337C6.06012 1.83337 3.56678 2.86671 2.90678 5.77337C2.18678 8.91337 4.16012 11.62 5.94678 13.3334C7.10012 14.4467 8.90678 14.4467 10.0601 13.3334C11.8401 11.62 13.8134 8.91337 13.1068 5.77337C12.4401 2.86671 9.94012 1.83337 8.00012 1.83337Z"/>
</svg>
